export default __webpack_public_path__ + "static/media/material-design.1a7efaca.png";